import { onSxSReadingPaneChange } from '../actions/publicActions';
import getOrCreateSxSStoreData from '../store/Store';
import { mutator } from 'satcheljs';

mutator(onSxSReadingPaneChange, actionMessage => {
    const { readingPaneState, sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).readingPaneState = readingPaneState;
});
